module.exports = __webpack_public_path__ + "static/media/place.7c8ba0bf.png";